import { LearningObject } from "../learningObject.model"
import { PremiumColors } from "./premiumColors.model"

export class PremiumCollectionOfResource {
    constructor(
        public canonicalUrl: string,
        public guid: string,
        public posterImages: any[] = [],
        public resources: LearningObject[] = [],
        public resourcesCount: number,
        public slug: string,
        public title: string,
        public logo?: string,
        public styleContent?: PremiumColors
    ) {}

    public static fromData(data): PremiumCollectionOfResource {
        return new PremiumCollectionOfResource(
            data.canonical_url,
            data.guid,
            data.posterImages,
            (data.resources || []).map((obj) => new LearningObject(obj)),
            data.resourcesCount,
            data.slug,
            data.title,
            data.logo,
            new PremiumColors(data.style_content || {})
        )
    }
}
